import type { GroupScheduleMeeting } from '@repo/types/groups';

export const REPEAT_LABELS: Record<GroupScheduleMeeting['repeat'], string> = {
  weekly: 'Co tydzień',
  biweekly: 'Co 2 tygodnie',
  monthly: 'Co miesiąc',
};
